__turbopack_context__.v({
  "icon": "NavMenuArrowButton-module__I3WW-q__icon",
  "iconCircle": "NavMenuArrowButton-module__I3WW-q__iconCircle",
  "navMenuArrowButton": "NavMenuArrowButton-module__I3WW-q__navMenuArrowButton",
});
